import React, { useState } from 'react';
import ToolLayout from '../../components/ToolLayout';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { Input } from '../../components/ui/input';
import { useToast } from '../../hooks/use-toast';
import { Copy, FileText } from 'lucide-react';

const LoremIpsumPage = () => {
  const { toast } = useToast();
  const [paragraphs, setParagraphs] = useState(3);
  const [output, setOutput] = useState('');

  const loremText = [
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.",
    "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident."
  ];

  const generate = () => {
    const count = Math.max(1, Math.min(20, parseInt(paragraphs) || 3));
    let result = [];
    for (let i = 0; i < count; i++) {
      result.push(loremText[i % loremText.length]);
    }
    setOutput(result.join('\n\n'));
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(output);
    toast({
      title: 'Copied!',
      description: 'Lorem ipsum text copied to clipboard',
    });
  };

  return (
    <ToolLayout
      title="Lorem Ipsum Generator"
      description="Generate placeholder text for your designs and mockups. Perfect for testing layouts and typography."
      icon={FileText}
    >
      <div className="space-y-6">
        <div className="flex gap-4 items-end">
          <div className="flex-1 max-w-xs">
            <Label htmlFor="paragraphs">Number of Paragraphs (1-20)</Label>
            <Input
              id="paragraphs"
              type="number"
              min="1"
              max="20"
              value={paragraphs}
              onChange={(e) => setParagraphs(e.target.value)}
            />
          </div>
          <Button onClick={generate}>Generate</Button>
        </div>

        {output && (
          <div>
            <div className="flex items-center justify-between mb-2">
              <Label>Generated Text</Label>
              <Button onClick={copyToClipboard} variant="ghost" size="sm">
                <Copy className="w-4 h-4 mr-2" />
                Copy
              </Button>
            </div>
            <Textarea
              value={output}
              readOnly
              rows={15}
              className="text-sm"
            />
          </div>
        )}
      </div>
    </ToolLayout>
  );
};

export default LoremIpsumPage;